import React from 'react';
import icon from '../../img/joinTest.jpg';
import styled from 'styled-components';

// Styleb
const BorderNone =styled.div`
    border: 0!important;
`;
const BackColor = styled.div` background-color: white;`;
const MarginWid = styled.div` margin: 0 auto; width: 80%`;
const Heading = styled.h3`padding:100px 0px 30px`;
const WidMax = styled.img`width: 100%`;
const Left = styled.p`margin-left: 30px`;
// 入室テストについての説明＆条件
const EnteringRoomTest = () => {
    return (
        <BackColor id="detail">
            <MarginWid>
                <Heading className="text-center mt-5 padding">次の1～4の条件の内、いずれかの条件を満たした生徒は、はりまやYT教室の入室を認めます。</Heading>
                <BorderNone class="card mb-3 ">
                    <div class="row g-0">
                        
                        <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title">１．入室テストについて</h5>
                                <h5 class="card-title">新小学4年生(現３年生)教室入室テスト</h5>
                                {/* <p class="card-text">日程:2024/2/12(月) 12:30～14:00(要予約) &ensp;13:00～テスト開始&ensp;15:00～ 合格者掲示</p> */}
                                <p class="card-text">日程:2024/2/12(月) 午前 10～11 時</p>
                                <p class="card-text">※日程のご都合が悪い場合はご相談ください。振替テスト等、調整いたします。</p>
                                <p class="card-text">場所:土佐塾はりまや本部教室 新館2-1</p>
                                <p className="card-text">科目:算・国(各30分)</p>
                                <p className="card-text">受験料:無料&ensp;(入室テスト見本は<a href="https://www.tosajuku.com/sample.pdf" target="_blank">こちら</a>)</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <WidMax src={icon} alt="..."/>
                        </div>
                    </div>
                </BorderNone>  

                <div class="card-body">
                    <p className="card-text pt-1 ">入室テスト後に面談を行い、合格した方がYTクラスにご参加いただけます。</p> 
                    <p className="card-text pt-1 ">※個別面談にご予定のある方はテスト受付の際にお知らせください。</p> 
                    <p className="card-text pt-1 ">こちらからご連絡の上、後日にテスト解説と個別面談を行ないます。</p> 
                </div>

                <div class="card-body">
                    <p className="card-text pt-1 ">２．土佐塾の公開テストにおいて上位の成績(小学4年生は上位30番以内、<br />&ensp;&ensp;&ensp;&ensp;小学5年生は上位100番以内)を収めた生徒。</p> 
                    <p className="card-text pt-1 ">３．四谷大塚全国統一小学生テストで総合偏差値が56以上の生徒。</p> 
                    <p className="card-text pt-1 ">４．四谷大塚公開組分けテストで、算国合計偏差値が52以上の生徒。</p>
                    <Left className="card-text pt-1 ">公開組分けテストは、<a href="https://www.yotsuyaotsuka.com/exam/kumiwake.php" target="_blank">こちら</a></Left>
                    <Left className="card-text pt-1 ">試験会場 : 土佐塾はりまやYT教室(要予約)</Left>
                     
                    {/* <p className="card-text pt-1 ">※  小4・小5YT教室の入室テストは、随時行っておりますのでいつでもご相談下さい。</p>  */}
                </div>

            </MarginWid>
        </BackColor>
        
      );
};

export default EnteringRoomTest;